import { connect, screenreaderNotification } from '@instructure/quiz-core';
import { GradingSidebarItem as SidebarItem } from './presenter';
var mapDispatchToProps = {
  screenreaderNotification: screenreaderNotification
};
export var GradingSidebarItem = connect(null, mapDispatchToProps)(SidebarItem);
export default GradingSidebarItem;